export default __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/scientific_inquiry3-601eefa77d9d6ad6717a520b554547bb.png";